module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<!-- assets/scripts/templates/factfinder-suggest-searchterm.lodash.tpl -->\n<div class="mdl_search__section mdl_search__section--results">\n    <div class="mdl_search__section-header">\n        <div class="mdl_search__section-title">' +
((__t = ( window.StringTranslation.get( 'SEARCH_TERM_SUGGESTIONS_HEADING' ) )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="mdl_search__section-content">\n        <div class="mdl_search__suggestions-searchterms">\n            ';
 suggestions.forEach( searchTerm => { ;
__p += '\n            <a href="/shop-suche/?query=' +
((__t = ( encodeURIComponent( searchTerm.name ) )) == null ? '' : __t) +
'&queryFromSuggest=true&userInput=' +
((__t = ( query )) == null ? '' : __t) +
'" class="mdl_search__suggestions-searchterm" data-suggest="' +
((__t = ( searchTerm.dataSuggest )) == null ? '' : __t) +
'">\n                ' +
((__t = ( mark( searchTerm.name ) )) == null ? '' : __t) +
'\n            </a>\n            ';
 }) ;
__p += '\n        </div>\n    </div>\n</div>\n';

}
return __p
};
